module.exports = __webpack_public_path__ + "img/metrolıfe.05beca53.png";